import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useApi } from "./use-api.ts";

export const useApiQuery = <T>(
  query: string,
  opts?: Omit<UseQueryOptions<T>, "queryKey" | "queryFn">,
  tokenOverride?: string,
) => {
  const { callApi } = useApi<T>(tokenOverride);

  return useQuery({
    queryKey: [query],
    queryFn: async () => callApi(query),
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    refetchInterval: 2_000,
    ...opts,
  });
};
